module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "detailPage"
  }, [_c('header', {
    staticClass: "detaiHead"
  }, [_c('span', {
    staticClass: "back",
    on: {
      "click": _vm.backRoute_
    }
  }, [_c('i', {
    staticClass: "dnnfont iconangleleft",
    staticStyle: {
      "position": "relative",
      "margin-right": "8px"
    }
  }), _vm._v("返回")]), _vm._v(" "), _c('span', {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.getName))]), _vm._v(" "), _c('span', {
    staticClass: "type"
  }, [_vm._t("type")], 2), _vm._v(" "), _c('span', {
    staticClass: "rightQuery"
  }, [_vm._t("right")], 2)]), _vm._v(" "), _c('main', {
    staticClass: "detailMain"
  }, [_vm._t("detailMain")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d6a11c58"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/DetailPage.vue
// module id = 1824
// module chunks = 9